<div class="form-control form-select filterOffcanvas__inputlabel"(focusin)="onDropdownFocusIn()" (focusout)="onDropdownFocusOut()">
  <div>
    <button class="drop-toggle btn flat" (click)="!isDisabled && showDropdown()" [disabled]="isDisabled"
      [ngClass]="{ 'borderColor': borderColor }">
      @if (isMultiSelect && checkedMultiList.length === 0) {
        <span class="spancolor">
          Select {{placeholder}}
        </span>
      }
      @if (isMultiSelect && checkedMultiList.length > 0) {
        <span class="spancolor">
          {{ checkedMultiList[0] }}@if (checkedMultiList.length > 1) {
          +{{ checkedMultiList.length - 1 }} more
        }
      </span>
    }
    @if (!isMultiSelect && !previousSeletedValues ) {
      <span class="spancolor">
        Select {{placeholder}}
      </span>
    }
    @if (!isMultiSelect && previousSeletedValues ) {
      <span class="spancolor">
        {{previousSeletedValues }}
      </span>
    }
  </button>
  @if(showClearIcon && (previousSeletedValues || checkedMultiList.length > 0)){
    <span class="clear-icon" (click)="clearSelection($event)">
      &times;
    </span>
  }
  @if (showDropDown) {
    <div #dropdownContainer class="drop-show" [style.--hovered-index]="hoveredIndex">
      <div class="drop-header">
        <div class="usersFilter__branchesField">
          <div class="usersFilter__branchWrappar">
            <img class="usersFilter__searchIcon" src="../../../../assets/Images/user-management/searchIcon.svg"
              alt="search" />
              <input #dropdownInput (input)="handleFilter($event)" class="usersFilter__input" [formControl]="searchControl"
                (keydown)="onKeyDown($event)" placeholder="Search" />
              </div>
            </div>
            @if (showEmailIcon) {
              <div class="createPackage__InviteUser" (click)="addItem(searchControl.value)">
                <img src="../../../../assets/Images/create-package/Addor.svg" alt="add" />
                Add External Email
              </div>
            }
          </div>
          <div class="drop-body" (scroll)="onDropdownScroll($event)">
            @if (isMultiSelect === true) {
              <div>
                @for (item of multiListData; track item; let i = $index) {
                  <label (mousedown)="$event.preventDefault()" (mouseenter)="onItemMouseEnter(item, i)" (mouseleave)="onItemMouseLeave()"
                      class="main-selection-label">
                      <div class="main-item-content">
                    <app-checkbox checkboxStatus="{{item.checked}}"
                    (checked)="getMultiSelectedValue($event.event.target.checked, item)"></app-checkbox>
                    <span>{{item.name}}</span>
                    @if(item.name === 'MA' && submenuList.length > 0){
                      <span class="submenu-arrow">»</span>
                    }
                    </div>
                  </label>
                }
              </div>
            }
            @if (isMultiSelect === false) {
              <div>
                @for (item of multiListData; track item; let i = $index) {
                  <label (mousedown)="singleSelectedValue(item)" [class.focused]="i === focusedIndex"
                    (click)="singleSelectedValue(item)">
                    {{ item.name }}
                  </label>
                }
              </div>
            }
          </div>
          @if(hoveredItem?.name === 'MA' && submenuList.length > 0){
            <div class="submenu-container" (mouseenter)="onSubmenuMouseEnter()" (mouseleave)="onItemMouseLeave()">
              @for (subItem of submenuList; track subItem) {
               <label (mousedown)="$event.preventDefault()" class="submenu-item">
                <app-checkbox checkboxStatus="{{isSubItemChecked(hoveredItem, subItem)}}"
                    (checked)="getMultiSelectedValue($event.event.target.checked, {_id: subItem, name: subItem}, true, hoveredItem)"></app-checkbox>
                <span>{{subItem}}</span>
            </label>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>